var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5.55228 15 6 14.5523 6 14C6 13.4477 5.55228 13 5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15Z",
    fill: "#1F3449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15Z",
    fill: "#1F3449"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5001H2.91L2.5 1.4001C2.47662 1.28546 2.41379 1.18265 2.32243 1.10957C2.23107 1.03648 2.11697 0.997743 2 1.0001H0V2.0001H1.59L3.5 11.6001C3.52338 11.7147 3.58621 11.8176 3.67757 11.8906C3.76893 11.9637 3.88303 12.0025 4 12.0001H13V11.0001H4.41L4 9.0001H13C13.1156 9.00293 13.2286 8.96561 13.3197 8.8945C13.4109 8.82339 13.4746 8.72289 13.5 8.6101L14.5 4.1101C14.5168 4.03591 14.5164 3.95888 14.4989 3.88487C14.4814 3.81085 14.4472 3.74181 14.399 3.68299C14.3508 3.62417 14.2898 3.57712 14.2206 3.54543C14.1515 3.51373 14.076 3.49823 14 3.5001ZM12.6 8.0001H3.81L3.11 4.5001H13.375L12.6 8.0001Z",
    fill: "#1F3449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchat);
export default __webpack_public_path__ + "static/media/Achat.d1af9458748d4a9fe2303a30e9bdd5f7.svg";
export { ForwardRef as ReactComponent };